// Edit a saved invoice (decision 170): the invoice screen opened on it. JL: "we need to make invoices editable after
// they're saved ... we can't go back and change prices".
import type { Invoice } from '@morales/shared';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../auth';
import { QueryView } from '../components/ui';
import { useLocale } from '../i18n';
import { qk } from '../queryClient';
import { canEditInvoice } from './InvoicePage';
import { InvoiceNewPage } from './InvoiceNewPage';

export function InvoiceEditPage() {
  const { t } = useLocale();
  const { me } = useAuth();
  const { id = '' } = useParams();
  // read fresh: the screen opens on the invoice as it is now (when it last changed guards the save)
  const query = useQuery({ queryKey: qk.invoice(id), queryFn: ({ signal }) => api.invoice(id, signal), staleTime: 0 });
  // the screen keeps the invoice it was opened on; someone else's change meanwhile is said, never typed over silently
  const [opened, setOpened] = useState<Invoice | null>(null);
  const [round, setRound] = useState(0);
  useEffect(() => {
    if (!opened && query.data) setOpened(query.data);
  }, [opened, query.data]);
  return (
    <QueryView query={query}>
      {(latest) => {
        if (!canEditInvoice(latest, me?.role)) {
          return (
            <div className="stack">
              <p className="note">{t('editInvoiceClosed')}</p>
              <Link to={`/invoices/${latest.id}`}>
                {t('invoice')} {latest.invoiceNo}
              </Link>
            </div>
          );
        }
        const inv = opened ?? latest;
        const changed = latest.updatedAt !== inv.updatedAt || latest.total !== inv.total;
        return (
          <>
            {changed ? (
              <p className="warn-band" role="alert">
                {t('editInvoiceChanged')}{' '}
                <button type="button" className="link" onClick={() => (setOpened(latest), setRound((n) => n + 1))}>
                  {t('editInvoiceReopen')}
                </button>
              </p>
            ) : null}
            <InvoiceNewPage key={`${inv.id}-${round}`} edit={inv} />
          </>
        );
      }}
    </QueryView>
  );
}
